import { useCallback, useState } from 'react';
import { IProcountorInvoicePreviewResponse } from '../ZentuvoInvoicingApi';
import { getInitialExpandedGroupIds } from '../procountorInvoiceHelpers';

type UseGroupExpansionResult = {
    expandedGroupIds: string[];
    isGroupExpanded: (groupId: string) => boolean;
    toggleGroupExpansion: (groupId: string) => void;
    ensureExpanded: (groupId: string) => void;
    resetExpansion: (response: IProcountorInvoicePreviewResponse) => void;
};

export function useGroupExpansion(): UseGroupExpansionResult {
    const [expandedGroupIds, setExpandedGroupIds] = useState<string[]>([]);

    const isGroupExpanded = useCallback(
        (groupId: string) => expandedGroupIds.indexOf(groupId) >= 0,
        [expandedGroupIds]
    );

    const toggleGroupExpansion = useCallback((groupId: string) => {
        setExpandedGroupIds((currentGroupIds) => {
            if (currentGroupIds.indexOf(groupId) >= 0) {
                return currentGroupIds.filter((value) => value !== groupId);
            }

            return currentGroupIds.concat(groupId);
        });
    }, []);

    const ensureExpanded = useCallback((groupId: string) => {
        setExpandedGroupIds((currentGroupIds) =>
            currentGroupIds.indexOf(groupId) >= 0 ? currentGroupIds : currentGroupIds.concat(groupId)
        );
    }, []);

    const resetExpansion = useCallback((response: IProcountorInvoicePreviewResponse) => {
        setExpandedGroupIds(getInitialExpandedGroupIds(response));
    }, []);

    return {
        expandedGroupIds,
        isGroupExpanded,
        toggleGroupExpansion,
        ensureExpanded,
        resetExpansion
    };
}
